import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

export const componentsRouter: RouteConfig = {
  path: '/components',
  component: Layout,
  redirect: 'noRedirect',
  name: 'ComponentDemo',
  meta: {
    title: '组件',
    icon: 'component',
    hidden: true
  },
  children: [
    {
      path: 'draggable-dialog',
      component: () => import(/* webpackChunkName: "draggable-dialog" */ '@/views/main/components-demo/draggable-dialog.vue'),
      name: 'DraggableDialogDemo',
      meta: { title: '可拖拽对话框' }
    },
    {
      path: 'bar-chart',
      component: () => import(/* webpackChunkName: "bar-chart" */ '@/views/main/components-demo/charts/bar-chart.vue'),
      name: 'BarChartDemo',
      meta: {
        title: '柱状图表',
        noCache: true
      }
    },
    {
      path: 'line-chart',
      component: () => import(/* webpackChunkName: "line-chart" */ '@/views/main/components-demo/charts/line-chart.vue'),
      name: 'LineChartDemo',
      meta: {
        title: '折线图',
        noCache: true
      }
    },
    {
      path: 'mixed-chart',
      component: () => import(/* webpackChunkName: "mixed-chart" */ '@/views/main/components-demo/charts/mixed-chart.vue'),
      name: 'MixedChartDemo',
      meta: {
        title: '混合图表',
        noCache: true
      }
    }
  ]
}

export const errorRouter: RouteConfig = {
  path: '/error',
  component: Layout,
  redirect: 'noRedirect',
  name: 'error',
  meta: {
    title: 'errorPages',
    hidden: true,
    icon: '404'
  },
  children: [
    {
      path: '401',
      component: () => import(/* webpackChunkName: "error-page-401" */ '@/views/main/error-page/401.vue'),
      name: 'Page401',
      meta: {
        title: 'page401',
        noCache: true
      }
    },
    {
      path: '404',
      component: () => import(/* webpackChunkName: "error-page-404" */ '@/views/main/error-page/404.vue'),
      name: 'Page404',
      meta: {
        title: 'page404',
        noCache: true
      }
    }
  ]
}
